import React from "react";
import HomeLayout from "../layouts/HomeLayout";
import ContactForm from "../components/Forms/ContactForm";
import StyleElement from "../components/StyleElement";
import HireSpaceModal from "../components/Modal/HireSpaceModal";
import MetaTags from "../components/MetaTags";
import {
  COMPANY_ADDRESS_LINE,
  COMPANY_CITY,
  COMPANY_EMAIL,
  COMPANY_PHONE,
} from "../constants/CompanyConstants";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <HomeLayout>
      <MetaTags
        title={t("meta.contact_title")}
        description={t("meta.contact_description")}
        keywords={t("meta.contact_keywords")}
        path="/contact"
      />
      <ContactForm />
      <div className={"position-relative"}>
        <StyleElement
          src={"assets/images/illustrations/illustratie-06.svg"}
          alt={""}
          bottom={-25}
          right={75}
        />
      </div>
      <HireSpaceModal />
    </HomeLayout>
  );
};

export default Contact;
